import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import Card from '../../elements/common/Card';
import { SelectOptions } from '../../elements/formElements/Select';
import { StringParams } from '../../helpers/types';
import useOnce from '../../hooks/useOnce';
import axios from '../../services/MyAxios';

import AttachForm from './AttachForm';

import { ROLE } from 'crm/helpers/Permissions';

const API = '/crea/api';

function AttachAdmin() {
    const { root, id } = useParams<StringParams>();
    const [options, setOptions] = useState<SelectOptions>({});
    const adminsUrlList = {
        affiliate: `${API}/admin/names/${ROLE.AFFILIATE_OWNER}`,
        sub_affiliate: `${API}/admin/names_without_sub_affiliate`,
        affiliate_owner: `${API}/admin/names/${ROLE.MASTER_AFFILIATE_AGENT}`,
        super_agent: `${API}/admin/names/${ROLE.MASTER_AGENT}`,
        reseller: `${API}/admin/names/${ROLE.SUPER_AGENT}`,
    };
    const adminsUrl = adminsUrlList.hasOwnProperty(root) ? adminsUrlList[root] : `${API}/admin/names`;
    const url = `${API}/${root}/${id}`;

    const handleAttach = async (admin: string) => {
        await axios.post(`${url}/admins/attach`, { admin });
    };

    useOnce(() => {
        const params = { resource_name: root, resource_id: id };
        axios.get(adminsUrl, { params }).then((response) => setOptions(response.data));
    });

    return (
        <Card title="Attach Admin">
            <AttachForm action={handleAttach} selectElements={options} field="admin" title="Admin" />
        </Card>
    );
}

export default AttachAdmin;
